import { FormApi } from 'final-form';

import { OnChange } from '@occc-app/design-system';
import { Constraint_Purchase_Threshold_Counting_Attribute } from '@occc/graphql';

import {
  shouldCloseSetLimitsSectionDueToProgressPerPeriod,
  shouldCloseSetLimitsSectionDueToProgressPerTransaction,
  shouldCloseSetLimitsSectionDueToTransactionLimit,
  getIsMinimumPurchaseConstraintSupported,
} from './utils/challenge.utils';
import {
  ChallengeConfigureFormValues,
  ChallengeConfigureFormValuesPaths,
  ProductChallengeEarningMechanism,
} from '../../types';
import { ChallengeType } from '../../constants';

type ChallengeFormValuesWatcherProps = {
  values: ChallengeConfigureFormValues;
  form: FormApi<ChallengeConfigureFormValues>;
};

const closeSetLimitsSection = (form: FormApi<ChallengeConfigureFormValues>) => {
  form.mutators.setFieldValue(
    'awardCount.isEnabled' satisfies ChallengeConfigureFormValuesPaths,
    false,
  );
};

const clearMinimumPurchaseConstraint = (form: FormApi<ChallengeConfigureFormValues>) => {
  form.mutators.setFieldValue(
    'minimumPurchaseConstraints.isEnabled' satisfies ChallengeConfigureFormValuesPaths,
    false,
  );
  form.mutators.setFieldValue(
    'minimumPurchaseConstraints.items' satisfies ChallengeConfigureFormValuesPaths,
    [
      {
        countProductsBy: Constraint_Purchase_Threshold_Counting_Attribute.Quantity,
      },
    ],
  );
};

export const ChallengeFormValuesWatcher = ({ values, form }: ChallengeFormValuesWatcherProps) => {
  return (
    <>
      <OnChange
        name={'productChallenge.earningMechanism' satisfies ChallengeConfigureFormValuesPaths}
      >
        {(earningMechanism: ProductChallengeEarningMechanism) => {
          if (!getIsMinimumPurchaseConstraintSupported(values.challengeType, earningMechanism)) {
            clearMinimumPurchaseConstraint(form);
          }

          if (
            shouldCloseSetLimitsSectionDueToProgressPerTransaction(
              values.challengeType,
              earningMechanism,
              values.awardCount,
            ) ||
            shouldCloseSetLimitsSectionDueToTransactionLimit(
              values.challengeType,
              values.awardCount,
              values.productChallenge?.earningMechanism,
            )
          ) {
            closeSetLimitsSection(form);
          }
        }}
      </OnChange>
      <OnChange name={'challengeType' satisfies ChallengeConfigureFormValuesPaths}>
        {(challengeType: ChallengeType | null) => {
          if (
            !getIsMinimumPurchaseConstraintSupported(
              challengeType,
              values.productChallenge?.earningMechanism,
            )
          ) {
            clearMinimumPurchaseConstraint(form);
          }

          if (
            shouldCloseSetLimitsSectionDueToProgressPerPeriod(challengeType, values.awardCount) ||
            shouldCloseSetLimitsSectionDueToProgressPerTransaction(
              challengeType,
              values.productChallenge?.earningMechanism,
              values.awardCount,
            ) ||
            shouldCloseSetLimitsSectionDueToTransactionLimit(
              challengeType,
              values.awardCount,
              values.productChallenge?.earningMechanism,
            )
          ) {
            closeSetLimitsSection(form);
          }
        }}
      </OnChange>
    </>
  );
};
